__turbopack_context__.v({
  "tagOverlay": "TrainingImagesTagViewer-module__nsYKoW__tagOverlay",
  "trash": "TrainingImagesTagViewer-module__nsYKoW__trash",
});
